import React from 'react';
import { createRoot } from 'react-dom/client';
import { createInertiaApp } from '@inertiajs/react';

createInertiaApp({
    title: (title) => title ? `${title} | SchoolPlex` : 'SchoolPlex | School Operations Platform',
    resolve: (name) => {
        // Resolve components dynamically from the Pages/Marketing folder
        const pages = require.context('./Pages/Marketing', true, /\.jsx$/);
        const page = pages(`./${name}.jsx`);
        return page.default || page;
    },
    setup({ el, App, props }) {
        createRoot(el).render(React.createElement(App, props));
    },
});
